import React, { useState } from "react"
import { useSubscription, useMutation, gql } from "@apollo/client"
import {
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
} from "@mui/material"
import { Delete, Edit } from "@mui/icons-material"
import { GET_FARMS_SUBSCRIPTION } from "../../gql/all_farms_sub"
import PaperWithHeading from "../../components/Layout/PaperWithHeading"
import FarmEditForm from "./FarmEditForm"

const ARCHIVE_FARM = gql`
  mutation ArchiveFarm($pk: Int!) {
    update_farm_by_pk(pk_columns: { id: $pk }, _set: { archived_at: "now()" }) {
      archived_at
      id
      name
    }
  }
`

export default function ListFarms({ waveBuoys }) {
  const [editing, setEditing] = useState(false)
  const { loading, error, data } = useSubscription(GET_FARMS_SUBSCRIPTION)
  const [archiveFarm] = useMutation(ARCHIVE_FARM)
  if (loading) return "Loading..."
  if (error) return `Error! ${error.message}`
  return (
    <PaperWithHeading title="All farms">
      <List>
        {data.farm.map((farm, index) => (
          <ListItem key={index}>
            <ListItemIcon>
              <IconButton
                onClick={() =>
                  archiveFarm({
                    variables: { pk: farm.id },
                  })
                }
              >
                <Delete />
              </IconButton>
              <IconButton onClick={() => setEditing(farm.id)}>
                <Edit />
              </IconButton>
            </ListItemIcon>
            <ListItemText primary={farm.name} />
            {editing === farm.id && (
              <FarmEditForm
                setEditing={setEditing}
                farm={farm}
                waveBuoys={waveBuoys}
              />
            )}
          </ListItem>
        ))}
      </List>
    </PaperWithHeading>
  )
}
